
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import increasingWhite from "../../assets/increasingWhite.png";
import increasingBlack from "../../assets/increasingBlack.png";
import userWhite from "../../assets/userWhite.png";
import userBlack from "../../assets/userBlack.png";
import settingWhite from "../../assets/settingWhite.png";
import settingBlack from "../../assets/settingBlack.png";
import homeWhite from "../../assets/homeWhite.png";
import homeBlack from "../../assets/homeBlack.png";
import mobileBlack from "../../assets/blackmobile.png"
import mobileWhite from "../../assets/whitemobile1.png"
import yieldBlack from "../../assets/yieldBlack.png"
import yieldWhite from "../../assets/yeildWhite.png"
import classWhite from "../../assets/class-white.png"
import classBlack from "../../assets/class-black.png"
import { useAnalysis } from "../../contexts/AnalysisContext";
import Swal from "sweetalert2";
import { urls } from "../../services/apiService";
import { useTranslation } from "react-i18next";
import Lottie from 'react-lottie';
import homeAnimation from "../../assets/home-icon.json";
import profileanimation from "../../assets/profile.json";
import yieldAnimation from "../../assets/yield.json";
import soilAnimation from "../../assets/soil.json";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");
  const { clearData } = useAnalysis();
  const { t } = useTranslation();

  const path = location.pathname;
  // const [showModal, setShowModal] = useState(false);
  const username = localStorage.getItem("User");

  // Check if username exists and does not already contain '@crop2x.com'
  if (username && !username.includes('@')) {
    const updatedUsername = username + "@crop2x.com";
    localStorage.setItem("User", updatedUsername);  // Save the updated username back to localStorage
  }


  const restrictedTabs = ["soil-analysis", "yield", "classification"]; // Restricted tabs
  const [usersData, setUsersData] = useState([]);
  const [userPlan, setUserPlan] = useState(null);
  const [showUpgrade, setShowUpgrade] = useState(false);


  const [diamondPrice, setDiamondPrice] = useState(0);
  const [platinumPrice, setPlatinumPrice] = useState(0);
  const [duration, setDuration] = useState(0);

  async function fetchPricing() {
    try {
      const response = await fetch(urls.getPricing);
      if (response.ok) {
        const data = await response.json();
        setDiamondPrice(data.diamond_price);
        setPlatinumPrice(data.platinum_price);
        setDuration(data.duration);
      } else {
        console.error("Failed to fetch pricing data");
      }
    } catch (error) {
      console.error("Error fetching pricing:", error);
    }
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: homeAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  const profileOptions = {
    loop: false,
    autoplay: true,
    animationData: profileanimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const yieldOptions = {
    loop: true,
    autoplay: true,
    animationData: yieldAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };


  useEffect(() => {
    if (showUpgrade) {
      fetchPricing();
    }
  }, [showUpgrade]);

  const plans = [
    {
      name: t("Diamond"),
      price: `PKR ${diamondPrice}/${duration} ${t("months")}`,
      features: [
        t("Access to Yield Prediction"),
        t("Limited Soil Analysis"),
        t("Basic Support"),
      ],
    },
    {
      name: t("Platinum"),
      price: `PKR ${platinumPrice}/${duration} ${t("months")}`,
      features: [
        t("Full Access to All Features"),
        t("Advanced Analytics"),
        t("Premium Support"),
      ],
    },
  ];


  useEffect(() => {
    const fetchUsersData = async () => {
      try {
        const response = await fetch(urls.getUsers); // Adjust URL as needed
        const data = await response.json();

        // Store the fetched users data
        setUsersData(data);

        // Find the logged-in user's plan
        const currentUser = data.find(user => user.username.toLowerCase() === username.toLowerCase());
        localStorage.setItem("userPlan", currentUser?.plan || "Free");
        if (currentUser) {
          setUserPlan(currentUser.plan); // Set the user's plan (Free, Diamond, Platinum)

        } else {
          setUserPlan(null); // Default case if user not found
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };

    fetchUsersData();
  }, [username]); // Runs whenever the username changes

  // Function to check if a tab should be restricted
  const isRestricted = (tab) => {
    if (!userPlan || userPlan === "Free") return true; // Block all tabs if user has no plan or a Free plan
    if (userPlan === "Diamond") return tab !== "yield"; // Allow only "yield", block others
    return false; // Platinum users have full access
  };
  useEffect(() => {
    // Set active tab based on the current path
    if (path === "/") {
      setActiveTab("home");
    } else if (path === "/profile") {
      setActiveTab("profile");
    } else if (path === "/analytics-dashboard") {
      setActiveTab("map");
    } else if (path === "/settings") {
      setActiveTab("settings");
    }

    // Clear analysis data if the user navigates away from the dashboard and not to home
    if (path !== "/analytics-dashboard" && path !== "/") {
      clearData();
    }
    // If user navigates from "analytics-dashboard" to "home", refresh the page
    const previousPath = sessionStorage.getItem("previousPath");
    if (path === "/" && previousPath === "/analytics-dashboard") {
      window.location.reload(); // Refresh the page
    }

    // Store the current path in session storage for comparison
    sessionStorage.setItem("previousPath", path);

  }, [path]);


  const handleTabClick = (tab) => {
    const isTabRestricted = restrictedTabs.includes(tab);

    // Free Plan: Only restrictedTabs are blocked
    if (userPlan === "Free" && isTabRestricted) {
      return; // Prevent navigation
    }

    // Diamond Plan: Can only access "yield", block others in restrictedTabs
    if (userPlan === "Diamond" && isTabRestricted && tab !== "yield") {
      return; // Prevent navigation
    }

    // Routes mapping
    const routes = {
      home: "/",
      profile: "/profile",
      yield: "/yield",
      classification: "/classification",
      map: "/analytics-dashboard",
      settings: "/settings",
      "soil-analysis": "/soil-analysis",
    };

    // Navigate only if tab exists in routes
    if (routes[tab]) {
      setActiveTab(tab);
      localStorage.removeItem("data"); // Clear local storage
      navigate(routes[tab]);
    }
  };



  const getIcon = (tabName) => {
    switch (tabName) {
      case "home":
        return isTabActive("home") ? homeBlack : homeWhite;
      case "profile":
        return isTabActive("profile") ? userBlack : userWhite;
      case "map":
        return isTabActive("map") ? increasingBlack : increasingWhite;
      case "yield":
        return isTabActive("yield") ? yieldBlack : yieldWhite;
      case "classification":
        return isTabActive("classification") ? classBlack : classWhite;
      case "settings":
        return isTabActive("settings") ? settingBlack : settingWhite;
      case "soil-analysis":
        return isTabActive("soil-analysis") ? mobileBlack : mobileWhite;
      default:
        return homeWhite;
    }
  };

  const showUpgradeModal = () => {
    Swal.fire({
      title: t("Access Restricted"),
      text: t("This feature is available for premium users only. Upgrade to unlock exclusive insights!"),
      icon: "info",
      confirmButtonText: t("Upgrade Now"),
      confirmButtonColor: "#3085d6",
      showCancelButton: true,
      cancelButtonText: t("Maybe Later"),
      cancelButtonColor: "#d33",
      backdrop: true,
      customClass: {
        popup: "animate__animated animate__fadeInUp",
      },
      preConfirm: () => {
        setShowUpgrade(true); // Show upgrade cards when "Upgrade Now" is clicked
      }
    });
  };


  // Handle Plan Card click, open WhatsApp
  const handlePlanSelection = (planName) => {
    const phoneNumber = "+923242607250"; // Example WhatsApp number

    // Send WhatsApp message based on selected plan
    const message = `Hello, I am interested in the ${planName} plan. My Username is ${username}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const isTabActive = (tab) => {
    return activeTab === tab;
  };

  return (
    <>
      <style>
        {`
    /* Float left-right + up + opacity animation */
    @keyframes floatCenter {
      0% { transform: translate(-4px, -3px); }
      25% { transform: translate(0, 0);  }
      50% { transform: translate(4px, -3px);  }
      75% { transform: translate(0, 0); }
      100% { transform: translate(-4px, -3px);  }
    }
    .animate-floatCenter {
      animation: floatCenter 5s ease-in-out infinite;
    }

    /* Spinning animation for Settings */
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .animate-spin-continuous {
      animation: spin 2s linear infinite;
    }
  `}
      </style>



      {/* Upgrade Plan Modal */}
      {showUpgrade && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]">
          <div className="bg-white shadow-lg rounded-2xl p-14 w-auto text-center animate__animated animate__fadeInUp">
            <h2 className="text-xl font-semibold text-gray-800">{t("Choose a Plan")}</h2>
            <div className="mt-4 flex gap-6">
              {plans.map((plan) => (
                <div
                  key={plan.name}
                  className="bg-gray-50 shadow-lg rounded-2xl p-6 w-70 text-center"
                >
                  <h3 className="text-xl font-semibold text-gray-800">{plan.name} {("Plan")}</h3>
                  <p className="text-gray-600 mt-2">{plan.price}</p>
                  <ul className="text-gray-500 mt-4 text-sm">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="mt-1">✅ {feature}</li>
                    ))}
                  </ul>
                  <button
                    onClick={() => handlePlanSelection(plan.name)}
                    className="mt-4 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
                  >
                    {t("Choose")} {plan.name}
                  </button>
                </div>
              ))}
            </div>
            <button
              onClick={() => setShowUpgrade(false)}
              className="mt-4 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition"
            >
              {t("Close")}
            </button>
          </div>
        </div>
      )}
      <div className="relative bg-green-500 lg:bg-white  lg:fixed h-[50px] md:h-[70px] lg:h-screen lg:w-[80px] xl:w-[90px] 2xl:w-[100px] flex items-center animate-[fadeIn_1s_ease-in-out]">
        <nav
          className={`w-full lg:w-[90%] bg-green-500 h-[95%] lg:rounded-r-[20px] xl:rounded-r-[24px] 2xl:rounded-r-[32px] flex lg:flex-col items-center justify-between gap-4 px-6 lg:px-0 lg:py-4 xl:py-6 2xl:py-8`}
        >
          {/* Logo */}
          <Link
            to="/"
            className="md:text-md xl:text-md 2xl:text-xl text-center text-white font-semibold"
          >
            AG5x
          </Link>

          {/* Navigation Icons */}
          <div className="w-full h-full flex lg:flex-col items-center justify-around gap-4 lg:pt-10 xl:pt-14 2xl:pt-16">
            {/* Home */}
            <div
              className={`flex justify-center items-center mt-2 lg:mt-4 2xl:mt-8 tooltip tooltip-bottom ${isTabActive("home")
                ? "w-[50px] md:w-[60px] lg:w-full h-full lg:h-[80px] xl:h-[70px] 2xl:h-[90px] ml-2 bg-white rounded-t-2xl lg:rounded-l-3xl"
                : ""
                }`}
              data-tip="Home"
              onClick={() => handleTabClick("home")}
            >
              {isTabActive("home") ? (
                <div className="  hover:scale-110 transition-transform duration-300">
                  <Lottie
                    options={defaultOptions}
                    height={55}
                    width={55}

                  />
                </div>
              ) : (
                <img
                  src={getIcon("home")}
                  alt="Home"
                  className="w-[25px] md:w-[30px] lg:w-[35px] 2xl:w-[40px] hover:scale-110 duration-300 cursor-pointer opacity-90"
                />
              )}

            </div>

            {/* Profile */}
            <div
              className={`flex justify-center items-center mt-2 lg:mt-4 tooltip tooltip-bottom 2xl:mt-8 ${isTabActive("profile")
                ? "w-[50px] md:w-[60px] lg:w-full ml-2 h-full lg:h-[60px] xl:h-[70px] 2xl:h-[80px] bg-white rounded-t-2xl lg:rounded-l-3xl"
                : ""
                }`}
              data-tip="Profile"
              onClick={() => handleTabClick("profile")}
            >
              {isTabActive("profile") ? (
                <div className="  hover:scale-110 transition-transform duration-300">
                  <Lottie
                    options={profileOptions}
                    height={45}
                    width={45}

                  />
                </div>
              ) : (
                <img
                  src={getIcon("profile")}
                  alt="Profile"
                  className="w-[25px] md:w-[30px] lg:w-[35px] 2xl:w-[40px] hover:scale-110 duration-300 cursor-pointer opacity-90"
                />
              )}
            </div>

            {/* Soil Analysis (Premium Feature - Disabled for MohsinTaj) */}
            <div
              className={`flex justify-center items-center mt-2 lg:mt-4 tooltip tooltip-bottom 2xl:mt-8 
    ${isTabActive("soil-analysis") ? "w-[50px] md:w-[60px] lg:w-full ml-2 h-full lg:h-[60px] xl:h-[70px] 2xl:h-[80px] bg-white rounded-t-2xl lg:rounded-l-3xl" : ""} 
    ${isRestricted("soil-analysis") ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={isRestricted("soil-analysis") ? showUpgradeModal : () => handleTabClick("soil-analysis")}
              data-tip={isRestricted("soil-analysis") ? "Coming Soon" : "Soil"}
            >
              <img
                src={getIcon("soil-analysis")}
                alt="Soil Analysis"
                className={`w-[35px] md:w-[40px] lg:w-[45px] 2xl:w-[50px] hover:scale-110 duration-300 cursor-pointer
    ${isTabActive("soil-analysis") ? "animate-floatCenter" : ""}`}
              />
            </div>




            {/* Yield Prediction */}
            <div
              className={`flex justify-center items-center mt-2 lg:mt-4 tooltip tooltip-bottom 2xl:mt-8 
    ${isTabActive("yield") ? "w-[50px] md:w-[60px] lg:w-full ml-2 h-full lg:h-[60px] xl:h-[70px] 2xl:h-[80px] bg-white rounded-t-2xl lg:rounded-l-3xl" : ""} 
    ${isRestricted("yield") ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={isRestricted("yield") ? showUpgradeModal : () => handleTabClick("yield")}
              data-tip={isRestricted("yield") ? "Coming Soon" : "Yield"}
            >
              {isTabActive("yield") ? (
                <div className="  hover:scale-110 transition-transform duration-300">
                  <Lottie
                    options={yieldOptions}
                    height={55}
                    width={55}

                  />
                </div>
              ) : (
                <img
                  src={getIcon("yield")}
                  alt="Yield Prediction"
                  className="w-[25px] md:w-[30px] lg:w-[35px] 2xl:w-[40px] hover:scale-110 duration-300 cursor-pointer opacity-90"
                />
              )}
            </div>

            {/* Classification Tab */}
            <div
              className={`flex justify-center items-center mt-2 lg:mt-4 tooltip tooltip-bottom 2xl:mt-8 
              ${isTabActive("classification") ? "w-[50px] md:w-[60px] lg:w-full ml-2 h-full lg:h-[60px] xl:h-[70px] 2xl:h-[80px] bg-white rounded-t-2xl lg:rounded-l-3xl" : ""} 
              ${isRestricted("classification") ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={isRestricted("classification") ? showUpgradeModal : () => handleTabClick("classification")}
              data-tip={isRestricted("classification") ? "Coming Soon" : "Classification"}
            >
              <img
                src={getIcon("classification")}
                alt="Classification"
                className={`w-[30px] md:w-[35px] lg:w-[40px] 2xl:w-[45px] hover:scale-110 duration-300 cursor-pointer
    ${isTabActive("classification") ? "animate-floatCenter" : ""}`}
              />

            </div>


            {/* Settings */}
            <div
              className={`flex justify-center items-center mt-2 lg:mt-4 tooltip tooltip-bottom 2xl:mt-8 ${isTabActive("settings")
                ? "w-[50px] md:w-[60px] lg:w-full ml-2 h-full lg:h-[60px] xl:h-[70px] 2xl:h-[80px] bg-white rounded-t-2xl lg:rounded-l-3xl"
                : ""
                }`}
              data-tip="Settings"
              onClick={() => handleTabClick("settings")}
            >
              <img
                src={getIcon("settings")}
                alt="Settings"
                className={`w-[25px] md:w-[30px] lg:w-[35px] 2xl:w-[40px] hover:scale-110 duration-300 cursor-pointer
    ${isTabActive("settings") ? "animate-spin-continuous" : ""}`}
              />

            </div>

            {/* Spacer */}
            <div className="flex-1 hidden lg:block"></div>
            {/* Modal for Premium Feature */}



          </div>
        </nav>
      </div>
    </>

  );

};

export default Sidebar;

